import { withoutLoopGuard } from '~~/shared/cohort';

// The cohort redirect adds _rl=1; remove it from the address bar, so a copied link starts a normal cohort decision.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const url = withoutLoopGuard(window.location.href);
    if (url) {
      window.history.replaceState(window.history.state, '', url);
    }
  });
});
